<template>
  <div class="whatsapp-integration-panel">
    <h2 class="main-title">接入 WhatsApp 提升沟通效率</h2>

    <div class="feature-list">
      <div class="feature-item">
        <div class="feature-icon icon-sync">
          <svg viewBox="0 0 24 24" fill="none">
            <path
                d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                fill="currentColor"
            />
          </svg>
        </div>
        <div class="feature-content">
          <h3 class="feature-title">聊天记录实时同步</h3>
          <p class="feature-desc">
            WhatsApp 聊天内容可同步至系统,沟通记录自动沉淀,避免信息分散遗漏。
          </p>
        </div>
      </div>

      <div class="feature-item">
        <div class="feature-icon icon-customer">
          <svg viewBox="0 0 24 24" fill="none">
            <path
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                fill="currentColor"
            />
          </svg>
        </div>
        <div class="feature-content">
          <h3 class="feature-title">支持客户建档管理</h3>
          <p class="feature-desc">
            支持将 WhatsApp 联系人一键建档,或关联至已有客户档案,方便统一管理与持续跟进。
          </p>
        </div>
      </div>

      <div class="feature-item">
        <div class="feature-icon icon-trace">
          <svg viewBox="0 0 24 24" fill="none">
            <path
                d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
                fill="currentColor"
            />
          </svg>
        </div>
        <div class="feature-content">
          <h3 class="feature-title">客户资料关联与追溯</h3>
          <p class="feature-desc">
            在 WhatsApp 会话中可直接查看客户完整档案,跟邮件记录统一留存,实现全程可追溯。
          </p>
        </div>
      </div>
    </div>

    <el-button type="primary" class="archive-btn" @click="$emit('archive')">
      归档对话
    </el-button>
  </div>
</template>

<script>
import ReturnEmails from "@/components/DiaPops/Returns/ReturnEmails.vue";

export default {
  name: "WhatsAppIntegrationPanel",
  components: {ReturnEmails},
  emits: ["archive"],
};
</script>

<style lang="scss" scoped>
.whatsapp-integration-panel {
  padding: 24px 20px 32px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.main-title {
  margin: 0 0 32px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  text-align: center;
}

.feature-list {
  margin-bottom: 32px;
}

.feature-item {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.feature-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }

  &.icon-sync {
    background: #e6f7ff;
    color: #52c41a;
  }

  &.icon-customer {
    background: #e6f7ff;
    color: #1890ff;
  }

  &.icon-trace {
    background: #fff1f0;
    color: #f5222d;
  }
}

.feature-content {
  flex: 1;
  min-width: 0;
}

.feature-title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.feature-desc {
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.archive-btn {
  width: 100%;
  background: #1890ff !important;
}
</style>
